var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Education/hat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "school",
    d: "M9.00006 2.26172L17.2474 6.75391V12.7552H15.7383V7.5611L9.00006 11.2461L0.752686 6.75391L9.00006 2.26172ZM3.77087 9.87738L9.00006 12.7552L14.2292 9.87738V12.8956L9.00006 15.7383L3.77087 12.8956V9.87738Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.4b410f67724a19428d673530aa6d91ad.svg";
export { ForwardRef as ReactComponent };